module.exports = __webpack_public_path__ + "img/3.3299886a.png";